import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useErrorScreen } from './hooks/useErrorScreen';

export const ErrorScreen = () => {
	const { actions } = useErrorScreen();

	return (
		<div className="flex h-[calc(100dvh-60px)] items-center md:h-auto">
			<div
				className="container mx-auto flex max-w-[620px] flex-col items-center gap-8 px-4 py-12 text-center"
				data-testid="error-screen"
			>
				<div className="flex flex-col gap-4">
					<Text as="h1" variant="heading" size="x-large">
						<Translate value="corgi.start_a_petition.common.error.unrecoverable.heading" />
					</Text>
					<Text as="p" variant="body">
						<Translate value="corgi.start_a_petition.common.error.unrecoverable.description" />
					</Text>
				</div>
				<Button
					className="mx-auto w-full md:w-auto"
					variant="primary"
					size="large"
					data-qa="primary-action-link"
					onClick={actions.handlePrimaryActionClick}
				>
					<Translate value="corgi.start_a_petition.common.error.unrecoverable.button" />
				</Button>
			</div>
		</div>
	);
};
